module.exports = __webpack_public_path__ + "static/media/angle-arrow-down.c3c72a6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/angle-arrow-down.svg
// module id = 320
// module chunks = 0